import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHookstate } from '@hookstate/core';
import { useClickOutside } from '@mantine/hooks';
import { useNavigationState } from '@store/hookstate';
import { initialNavigationState } from '@store/hookstate/navigation/navigation';
import { checkDevice } from '@store/redux/features/mobile/mobileSelectors';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import AccountsSection from './AccountsSection';
import { Container, Toggle } from './BeamOnSidebar.styles';
import { MainSidebarBody } from './MainSidebarBody';

const Sidebar = () => {
  const navigationState = useNavigationState();
  const { minLeft, maxLeft } = initialNavigationState;

  const isMouseOver = useHookstate(false);
  const { isMobile } = useSelector(checkDevice());

  const [excludeElementsRef, setExcludeElements] = useState<HTMLElement[]>([]);
  const [containerRef, setContainerRef] = useState<HTMLElement | null>(null);

  function getElements() {
    const els = [...excludeElementsRef];
    if (containerRef) els.push(containerRef);
    return els;
  }
  useClickOutside(
    () => {
      if (navigationState.sidebarOpen.value) navigationState.closeNavigation();
    },
    ['mouseup', 'touchend'],
    getElements(),
  );
  const shouldShowToggle =
    isMouseOver.get() || navigationState.sidebarOpen.get();
  const showToggle = shouldShowToggle && !isMobile;

  const isOpen = navigationState.sidebarOpen.get();
  const showContent = !(isMobile && !isOpen);
  const navigationTab = navigationState.navigationTab.get();
  return (
    <Container
      data-open={isOpen}
      ref={setContainerRef}
      onMouseOver={() => {
        if (!isMouseOver.get()) isMouseOver.set(true);
      }}
      onMouseLeave={() => {
        if (isMouseOver.get()) isMouseOver.set(false);
      }}
      minLeft={minLeft}
      maxLeft={maxLeft}
      className="new-icon reset-global"
      data-tab={navigationTab}
    >
      {showToggle && (
        <Toggle onClick={navigationState.toggleNavigation}>
          <FontAwesomeIcon
            color="#1C285A99"
            icon={
              navigationState.sidebarOpen.get() ? faChevronLeft : faChevronRight
            }
            size="sm"
          />
        </Toggle>
      )}

      {showContent && (
        <>
          {navigationTab === 'root' && (
            <MainSidebarBody excludeElementsRef={setExcludeElements} />
          )}
          {navigationTab === 'accounts' && <AccountsSection />}
        </>
      )}
    </Container>
  );
};

export { Sidebar };
